import { createSelector } from 'reselect';
export const REJECT_TENANT_ORDER_POPUP = 'rejectTenantOrderPopup';
export const APPROVE_TENANT_ORDER_POPUP = 'approveTenantOrderPopup';
const popupManagerSelector = state => state.popupManager;
export const isRejectTenantOrderPopupShownSelector = createSelector(popupManagerSelector, popupManager => {
  return popupManager.shownPopup === REJECT_TENANT_ORDER_POPUP;
});
export const isApproveTenantOrderPopupShownSelector = createSelector(popupManagerSelector, popupManager => popupManager.shownPopup === APPROVE_TENANT_ORDER_POPUP);